import { OfferingCode } from "../../../models";
import { get as Ajax_get } from "../app/Ajax";

export const API_URL_BRING_POSTALCODES = (postcode: string) =>
    `https://fraktguide.bring.no/fraktguide/postalCode.json?country=NO&pnr=${postcode}`;

export const API_URL_AVAILABLE_NUMBERS = (type: string, subscriptionId: string) =>
    `/shop/api/getavailablenumbersfororder/${type}/${subscriptionId}`;

export const API_URL_EXTEND_ORDER = "/shop/api/v2/cart/extend";

export const API_URL_FETCH_CART = "/shop/api/v2/cart";
export const API_URL_ADD_PHONE = "/shop/api/v2/cart/phone/add";
export const API_URL_ORDER = "/shop/api/v2/cart/order";
export const API_URL_ADD_SUBSCRIPTION = "/shop/api/v2/cart/subscription";
export const API_URL_ADD_SUBSCRIPTION_TO_BUNDLE = "/shop/api/v2/cart/offering-code/add";
export const API_URL_ADD_ACCESSORY = "/shop/api/v2/cart/accessory";
export const API_URL_REMOVE_ACCESSORY = (sku: string) => `/shop/api/v2/cart/accessory/${sku}`;
export const API_URL_ADD_SERVICE = "/shop/api/v2/cart/service/add";
export const API_URL_ADD_SERVICE_RETAILER = "/shop/api/v2/cart/retailer/service/add";
export const API_URL_REMOVE_SERVICE = "/shop/api/v2/cart/service/remove";
export const API_URL_ADD_INSURANCE_DUMMY = "/shop/api/v2/cart/insurance/dummy/add";
export const API_URL_REMOVE_ITEM_BY_ID = (id: string) => `/shop/api/v2/cart/cart-item/remove/${id}`;
export const API_URL_REMOVE_ITEM_BY_CART_ITEM_ID = (cartItemId: string) => `/shop/api/v2/cart/cart-item/${cartItemId}`;
export const API_REMOVE_HARDWARE_ITEM_FROM_BUNDLE = (bundleId: string, sku: string) =>
    `/shop/api/v2/cart/smart-discount/hardware_item/remove/${bundleId}/${sku}`;
export const API_REMOVE_SMART_DISCOUNT_FROM_HARDWARE_ITEM = (bundleId: string, sku: string) =>
    `/shop/api/v2/cart/smart-discount/remove/${bundleId}/${sku}`;
export const API_URL_ADD_EXTRA_SIM_TO_CART = "/shop/api/v2/cart/extra-sim/add";

export const API_URL_FETCH_DELIVERY_AND_PAYMENT_ALL = "/shop/api/delivery-and-payment/all";

export const API_URL_ADD_WEBDEAL_ACCESSORY_TO_CART = "/shop/api/v2/cart/webdeal-accessory";
export const API_URL_GET_INSURANCE_INFO = (sku: string, offeringCode: OfferingCode) =>
    `/shop/api/insuranceinfo?sku=${sku}&subscriptionCode=${offeringCode}`;
export const API_URL_ADD_ONBOARDING_MOBILE_SUPPORT = "/shop/api/v2/cart/mobile-support/add";
export const API_URL_REMOVE_ONBOARDING_MOBILE_SUPPORT = (sku: string) =>
    `/shop/api/v2/cart/mobile-support/remove/${sku}`;
export const API_URL_REMOVE_MOBILE_REFUND = "/shop/api/mobilerefund";

export const fetchCityFromPostcode = (postcode: string) => {
    const validPostalCodes = ["NORMAL", "SPECIALNOSTREET"];
    const url = API_URL_BRING_POSTALCODES(postcode);

    const response = Ajax_get<{ postalCodeType: string; result: string; valid: boolean }>({
        url,
        dataType: "JSONP",
    });

    return response.then(({ valid, postalCodeType, result }) => {
        if (valid && validPostalCodes.includes(postalCodeType)) {
            return result;
        } else {
            throw new Error();
        }
    });
};

export const API_URL_GET_EXTRA_SIM_PRICES = (memberId: string, phoneNumber: string) =>
    `/shop/api/get-extra-sim-prices/${memberId}/${phoneNumber}`;

export const API_URL_APPLY_FLEXIBLE_LEASE = "/shop/api/v2/cart/apply-flexible-lease";

export const API_URL_ADD_RETAILER_INFO = "/shop/api/retailer/info";

export const API_URL_GET_HOLIDAY_DATA = "/shop/api/get-holiday-data";

export const API_URL_GET_ORDER_SUMMARY = "/shop/ordre-oppsummering"; // In norwegian as url is exposed to end user on pdf link
